import { Row, View } from '@amzn/stencil-react-components/layout';

import { ReviewQuestionToggleField } from './ReviewQuestionToggleField';
import { ConfigField } from './ConfigField';
import { useMessages } from '../../../shared/i18n/useMessages';
import {
  CONFIG_BUNDLE,
  type ConfigKey,
  dtProps,
  type QuestionConfigCardProps,
  TOGGLE_ROWS,
  TOGGLE_TRACKING_ROOT,
} from './questionConfigShared';

/**
 * The four requirement toggles arranged as a 2×2 grid (Comment | Attachment
 * columns; Fail row then Pass row), matching the manual question flow. Each
 * toggle gets a ConfigField label-on-top with an info tooltip. Rows come from
 * {@link TOGGLE_ROWS}; every toggle is fully controlled via `patchConfig`.
 */
export function RequirementTogglesGrid({
  config,
  patchConfig,
  disabled,
  dataTestId,
}: QuestionConfigCardProps): JSX.Element {
  const { t } = useMessages<ConfigKey>(CONFIG_BUNDLE);
  const infoAltText = t('configInfoAltText');

  return (
    <>
      {TOGGLE_ROWS.map((row) => (
        <Row
          key={row.map((toggle) => toggle.field).join('-')}
          gridGap="dimensions.spacing.400"
          flexWrap="wrap"
        >
          {row.map((toggle) => (
            <View key={toggle.field} flex={1} minWidth={0}>
              <ConfigField
                label={t(toggle.labelKey)}
                info={t(toggle.infoKey)}
                infoAltText={infoAltText}
                renderLabel={(labelId) => (
                  <ReviewQuestionToggleField
                    checked={config[toggle.field]}
                    onChange={(checked) => patchConfig({ [toggle.field]: checked })}
                    trackingId={`${TOGGLE_TRACKING_ROOT}.${toggle.trackingSuffix}`}
                    labelId={labelId}
                    disabled={disabled}
                    {...dtProps(dataTestId, toggle.testSuffix)}
                  />
                )}
              />
            </View>
          ))}
        </Row>
      ))}
    </>
  );
}
